import React, { Component } from 'react';
import classNames from 'classnames';
import dateFormat from 'dateformat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import Dialog from '../dialog/dialog.js';
import { isValidDate, numberWithCommas, parseDate } from '../../utils/web/index.js';
import './jsonViewer.scss';

class JsonViewer extends Component {
  constructor(props) {
    super(props);
    var {
      json
    } = props;
    var startOpen = false;

    if (typeof json === 'string') {
      if (json.length && (json[0] === '[' || json[0] === '{')) {
        startOpen = true;
      }
    } else if (typeof json === 'object') {
      startOpen = true;
    }

    this.containerRef = /*#__PURE__*/React.createRef();
    this.state = {
      jsonOpen: startOpen,
      maxPreviewChars: 60
    };

    this.windowResizeFunc = () => {
      if (this.containerRef.current?.offsetWidth) {
        this.setState({
          maxPreviewChars: Math.floor(this.containerRef.current.offsetWidth / 8)
        });
      }
    };
  }

  componentDidMount() {
    if (this.containerRef.current?.offsetWidth) {
      this.setState({
        maxPreviewChars: Math.floor(this.containerRef.current.offsetWidth / 8)
      });
    }

    window.addEventListener('resize', this.windowResizeFunc);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResizeFunc);
  }

  render() {
    var {
      json
    } = this.props;
    var {
      jsonOpen,
      maxPreviewChars
    } = this.state;
    var parsedJson = json;

    if (typeof json === 'string') {
      try {
        parsedJson = JSON.parse(json);
      } catch (error) {
        parsedJson = json;
      }
    }

    var content = null;

    if (parsedJson && typeof parsedJson === 'object') {
      var objectString = getObjectStringRepresentation(parsedJson, maxPreviewChars);
      content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "objectPreview"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faPlay,
        className: classNames('objectDropdownArrow noSelect', {
          open: jsonOpen
        }),
        onClick: () => this.setState({
          jsonOpen: !jsonOpen
        })
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          cursor: 'pointer'
        },
        onClick: () => this.setState({
          jsonOpen: !jsonOpen
        })
      }, objectString)), jsonOpen && /*#__PURE__*/React.createElement("div", {
        className: "objectItemsContainer"
      }, sortObject(parsedJson).map(([key, value]) => /*#__PURE__*/React.createElement(JsonViewerChild, {
        key: key,
        myKey: key,
        value: value,
        maxPreviewChars: maxPreviewChars
      }))));
    } else {
      content = JSON.stringify(parsedJson);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames('jsonViewer'),
      ref: this.containerRef
    }, content);
  }

}

export default JsonViewer;
export function JsonViewerDialog(props) {
  var {
    close,
    json,
    label
  } = props;
  return /*#__PURE__*/React.createElement(Dialog, {
    className: "dialogViewJson",
    close: close,
    header: `View JSON ${label ? `- ${label}` : ''}`,
    height: 500,
    width: 700
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(JsonViewer, {
    json: json
  })));
}

function sortObject(object) {
  if (Array.isArray(object)) {
    return Object.entries(object);
  } else {
    return Object.entries(object).sort((a, b) => a[0].localeCompare(b[0]));
  }
}

function getObjectStringRepresentation(obj, maxPreviewChars) {
  if (typeof obj === 'string') {
    return `'${obj}'`;
  } else if (typeof obj !== 'object') {
    return JSON.stringify(obj);
  } else if (obj == null) {
    return JSON.stringify(obj);
  }

  var isArray = Array.isArray(obj);
  var entries = sortObject(obj);
  var overflow = false;
  var objectString = '';

  for (var [key, value] of entries) {
    var string = '';

    if (objectString.length) {
      string += ', ';
    }

    if (!isArray) {
      string += `${key}: `;
    }

    if (value == null) {
      string += JSON.stringify(value);
    } else if (Array.isArray(value)) {
      string += `Array(${value.length})`;
    } else if (typeof value === 'object') {
      string += '{...}';
    } else if (typeof value === 'string') {
      string += `'${value}'`;
    } else {
      string += JSON.stringify(value);
    }

    if (objectString.length + string.length > maxPreviewChars - 5) {
      overflow = true;
    } else {
      objectString += string;
    }
  }

  ;

  if (overflow) {
    objectString += ', ...';
  }

  if (isArray) {
    objectString = `(${obj.length}) [${objectString}]`;
  } else {
    objectString = `{${objectString}}`;
  }

  return objectString;
}

class JsonViewerChild extends Component {
  constructor(props) {
    super(props);
    var {
      value
    } = props;
    this.state = {
      objectOpen: false,
      showFormattedValue: false
    };

    if (typeof value === 'string' || typeof value === 'number') {
      var dateValue = parseDate(value);

      if (isValidDate(dateValue)) {
        this.hasFormattableValue = true;
        this.formattableValue = dateValue;
      } else if (typeof value === 'number') {
        this.hasFormattableValue = true;
        this.formattableValue = value;
      }
    }
  }

  getObjectString() {
    var {
      maxPreviewChars,
      myKey,
      value: obj
    } = this.props;
    var {
      showFormattedValue
    } = this.state;
    var onClick = this.hasFormattableValue ? () => this.setState({
      showFormattedValue: !this.state.showFormattedValue
    }) : () => {};
    obj = showFormattedValue ? this.formattableValue : obj;

    if (typeof obj === 'string') {
      return /*#__PURE__*/React.createElement("span", {
        className: classNames(typeof obj, {
          pointer: this.hasFormattableValue
        }),
        onClick: onClick
      }, "'", obj, "'");
    } else if (typeof obj === 'number') {
      var displayNumber = JSON.stringify(obj);

      if (showFormattedValue) {
        displayNumber = numberWithCommas(obj);
      }

      return /*#__PURE__*/React.createElement("span", {
        className: classNames(typeof obj, {
          pointer: this.hasFormattableValue
        }),
        onClick: onClick
      }, displayNumber);
    } else if (typeof obj !== 'object') {
      return /*#__PURE__*/React.createElement("span", {
        className: classNames(typeof obj, {
          pointer: this.hasFormattableValue
        }),
        onClick: onClick
      }, JSON.stringify(obj));
    } else if (obj == null) {
      return /*#__PURE__*/React.createElement("span", {
        className: "null"
      }, JSON.stringify(obj));
    } else if (obj instanceof Date) {
      return /*#__PURE__*/React.createElement("span", {
        className: "date pointer",
        onClick: onClick
      }, dateFormat(obj, 'ddd mmm d yyyy hh:MM:ss.l tt "GMT"p'));
    }

    var objectString = getObjectStringRepresentation(obj, maxPreviewChars - 2 - 2 - myKey.length); // 2 for nested value, 2 for ': ' after the key length

    return /*#__PURE__*/React.createElement("span", {
      style: {
        cursor: 'pointer'
      },
      onClick: () => this.setState({
        objectOpen: !this.state.objectOpen
      })
    }, objectString);
  }

  render() {
    var {
      maxPreviewChars,
      myKey,
      value
    } = this.props;
    var {
      objectOpen
    } = this.state;
    var hasDropdown = typeof value === 'object' && value != null;
    var isArray = Array.isArray(value);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "objectPreview",
      key: myKey
    }, hasDropdown ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faPlay,
      className: classNames('objectDropdownArrow noSelect', {
        open: objectOpen
      }),
      onClick: () => this.setState({
        objectOpen: !objectOpen
      })
    }) : /*#__PURE__*/React.createElement("span", {
      className: "objectArrowSpacer"
    }), /*#__PURE__*/React.createElement("span", {
      className: "objectKey",
      onClick: () => hasDropdown && this.setState({
        objectOpen: !objectOpen
      })
    }, myKey), ': ', objectOpen ? isArray ? `Array(${value.length})` : '' : this.getObjectString()), hasDropdown && objectOpen && /*#__PURE__*/React.createElement("div", {
      className: "objectItemsContainer"
    }, sortObject(value).map(([key, value]) => /*#__PURE__*/React.createElement(JsonViewerChild, {
      key: key,
      myKey: key,
      value: value,
      maxPreviewChars: maxPreviewChars - 2
    }))));
  }

}